module.exports = __webpack_public_path__ + "17_hair_silver.acb0f9c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer5/17_hair_silver.png
// module id = kSvA
// module chunks = 0